<template>
  <div class="loading-container q-mt-sm">
    <div v-for="n in 6" :key="n" class="field-group">
      <div class="field-group__row no-wrap justify-left">
        <div class="skeleton skeleton-title"></div>
        <div
          class="skeleton skeleton-text"
          :class="{
            'skeleton-text-short': n % 3 === 0,
            'skeleton-text-medium': n % 3 === 1,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';

@Component({ name: 'LoadingSkeleton' })
export default class LoadingSkeleton extends Vue {}
</script>
